import { styled } from '@mui/material';

const pxPerXCm = (dpr, cm) => {
  const baseDpi = 96;
  return ((baseDpi * dpr) / 2.54) * cm;
};

const Image = styled('img')`
  padding-top: 4px;
  margin-right: auto;
  margin-left: 8px;
  width: ${({ devicePixelRatio }) => pxPerXCm(devicePixelRatio, 2)}px;
  height: ${({ devicePixelRatio }) => pxPerXCm(devicePixelRatio, 2)}px;
`;

export default Image;
